import { createContext, useMemo, createElement, useContext } from 'react';
import { emptyAnalytics, jitsuAnalytics } from '@jitsu/js';

var JitsuContext = createContext(null);

var JitsuProvider = function JitsuProvider(props) {
  var instance = useMemo(function () {
    if (props.options.disabled) {
      return {
        analytics: emptyAnalytics
      };
    } else if (!props.options.host) {
      var msg = "<JitsuProvider />. Jitsu host is not defined. Jitsu will not be initialized";
      console.error("%c" + msg, "color: red; font-weight: bold;");
      return {
        analytics: emptyAnalytics
      };
    } else {
      return {
        analytics: jitsuAnalytics(props.options)
      };
    }
  }, [props.options.disabled, props.options.host]);
  return createElement(JitsuContext.Provider, {
    value: instance
  }, props.children);
};

function useJitsu(opts) {
  var jitsuInstance = useContext(JitsuContext);
  if (opts !== null && opts !== void 0 && opts.disabled) {
    return {
      analytics: emptyAnalytics
    };
  }
  if (!jitsuInstance) {
    if (opts !== null && opts !== void 0 && opts.host || opts !== null && opts !== void 0 && opts.echoEvents) {
      return {
        analytics: jitsuAnalytics(opts)
      };
    } else {
      var msg = "Before calling useJitsu() hook, please wrap your component into <JitsuProvider />. Read more in http://jitsu.com/docs/sending-data/js-sdk/react";
      console.error("%c" + msg, "color: red; font-weight: bold;");
      return {
        analytics: emptyAnalytics
      };
    }
  } else if (opts !== null && opts !== void 0 && opts.host || opts !== null && opts !== void 0 && opts.echoEvents) {
    throw new Error("Jitsu client already set up with <JitsuProvider /> and cannot be overridden. Read more in http://jitsu.com/docs/sending-data/js-sdk/react");
  } else if (jitsuInstance.analytics) {
    return jitsuInstance;
  } else {
    throw new Error("<JitsuProvider /> is not initialized with undefined analytics instance");
  }
}

export { JitsuContext, JitsuProvider, useJitsu };
//# sourceMappingURL=index.modern.js.map
